import { Modal as AntdModal } from "antd";
import styled from "styled-components";
import { useEffect, useState } from "react";
import StompSocket from "@/components/websocket/stomp-socket";
import Cookie from "project-config/utils/cookie";
import {
  PAY_SUCCESS_SOCKET,
  PAY_HAS_SCANNED_SOCKET,
} from "@/components/websocket/constant";
import { useGlobalStore } from "@/store/GlobalStore";
import { isDev } from "project-config/utils/env";
import SuccessImage from "../../images/recharge-success.png";
import SuccessBg from "../../images/success-bg.png";
import { useFetchPicActivity } from "@/pages/client-top-up/hook/useFetchPicActivity";
import request from "project-config/services/request/request";
import { useClientTopUpStore } from "../../store";
import { useLocation } from "react-router-dom";

interface StompClientProps {
  body: string;
}

export function PaySuccessSocket() {
  const { userInfo } = useGlobalStore();
  const { clientActivityInfoListRefetch } = useFetchPicActivity();
  const [stompClient, setStompClient] = useState<StompSocket>();
  const [openSuccessTip, setOpenSuccessTip] = useState(false);
  const { fetchUserData } = useGlobalStore();
  const { setHasScanned } = useClientTopUpStore();
  const location = useLocation();
  const routeTheme = new URLSearchParams(location.search).get("theme");
  const acknowledge = (
    userId: string | number,
    stompTempClient: StompSocket
  ) => {
    // @ts-ignore
    if (stompTempClient.stompClient.readyState !== 1) return;
    stompTempClient.send(`/rendering/message/greeting.${userId}`);
  };
  const subscribe = (stompTempClient: StompSocket) => {
    stompTempClient.subscribe(
      "/user/topic/msg",
      (frameObject: StompClientProps) => {
        if (frameObject.body) {
          switch (JSON.parse(frameObject.body).business) {
            case PAY_SUCCESS_SOCKET:
              // setOpenSuccessTip(true);
              break;
            case PAY_HAS_SCANNED_SOCKET:
              setHasScanned(true);
              break;
            default:
              break;
          }
        }
      }
    );
  };

  const connectSocket = (userId: string | number) => {
    if (stompClient && stompClient.stompClient.connected && !userId) return;
    const userKey = Cookie.getCookie("rayvision_userKey");
    const stompTempClient = new StompSocket(
      `wss://${
        isDev() ? "task-pre" : "task"
      }.renderbus.com/websocket?userKey=${userKey}`
    );
    setStompClient(stompTempClient);
    stompTempClient.connect(
      {
        userKey: userKey,
      },
      () => {
        acknowledge(userId, stompTempClient);
      },
      () => {
        subscribe(stompTempClient);
      }
    );
  };

  const closePaySuccessDialog = () => {
    setOpenSuccessTip(false);
    fetchUserData();
    clientActivityInfoListRefetch();
    window.location.reload();
  };

  const fetchRechargeMessage = async () => {
    const { code, data } = await request.get(
      "/api/rendering/user/getRechargeMessage"
    );
    if (code === 200 && data) {
      setOpenSuccessTip(true);
    }
  };

  useEffect(() => {
    if (!userInfo || stompClient) return;
    connectSocket(userInfo.userId || "");
    return () => {
      if (!stompClient) return;
      (stompClient as StompSocket).unSubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  useEffect(() => {
    const intervalId = setInterval(fetchRechargeMessage, 2000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <AntdModal
      centered
      open={openSuccessTip}
      footer={null}
      width={400}
      onCancel={() => closePaySuccessDialog()}
      children={
        <ClientPaySuccessContainer>
          <img width={128} height={128} src={SuccessImage} alt="" />
          {routeTheme !== "dark" && (
            <img src={SuccessBg} alt="" className="success-bg" />
          )}
          <div className="success">充值成功</div>
          <ClientConfirmButton onClick={() => closePaySuccessDialog()}>
            确认
          </ClientConfirmButton>
        </ClientPaySuccessContainer>
      }
    />
  );
}

const ClientPaySuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .success {
    color: ${(p) => p.theme["color-text-1"]};
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
  }
  .success-bg {
    position: absolute;
    width: 400px;
    top: 0;
  }
`;

const ClientConfirmButton = styled.div`
  width: 104px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 4px;
  cursor: pointer;
  background: rgba(60, 123, 234, 1);
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 30px;
  margin-top: 46px;
  &:hover {
    background: rgba(103, 154, 244, 1);
  }
  &:active {
    background: rgba(29, 86, 186, 1);
  }
`;
